import { useEffect, useState } from "react";
import { Card, CardBody, Col, Input, Label, Row } from "reactstrap";
import { Btn } from "../../../AbstractElements";
import Dropzone from "react-dropzone-uploader";
import { useNavigate } from "react-router";
import { useDataFetch } from "../../Hooks/Use-data-fetch";
import { toast } from "react-toastify";
import { API_BASE_URL } from "../../api/api";

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result.split(",")[1]);
    reader.onerror = (error) => reject(error);
  });

export const Banner = () => {
  const navigate = useNavigate();
  const { getData, postData, patchData, invalidateQuery } = useDataFetch();

  const [imageName, setImageName] = useState(null);
  const [isEnabled, setIsEnabled] = useState(true);


  const { data: bannerResponse, isLoading } = getData(
    ["banner"],
    "/product/get/banner"
  );

  useEffect(() => {
    if (bannerResponse?.banner) {
      setImageName(bannerResponse.banner.image || null);
      setIsEnabled(bannerResponse.banner.status);
    }
  }, [bannerResponse]);


  const { mutateAsync: saveBanner, isPending: saving } = postData(
    "/product/banner",
    {},
    {
      onSuccess: (response) => {
        if (response.message === "banner_save_or_update_success") {
          toast.success("Configuración guardada correctamente");
          invalidateQuery(["banner"]);
        } else {
          toast.error("Error al guardar configuración");
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );


  const { mutateAsync: toggleBanner } = patchData(
    "/product/banner/toggle-status",
    {},
    {
      onSuccess: (response) => {
        if (response?.banner) {
          setIsEnabled(response.banner.status);
          toast.success("Estado actualizado");
          invalidateQuery(["banner"]);
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );



  const { mutateAsync: uploadBanner } = postData(
    "/product/upload-file-banner",
    {},
    {
      onSuccess: (response) => {
        if (response.message === "file_create_success") {
          setImageName(response.data.fileName);
          toast.success("Imagen subida correctamente");
        } else {
          toast.error("Error al subir imagen");
        }
      },
      onError: (error) => {
        toast.error(error.message);
      },
    }
  );

  const handleChangeStatus = async (fileWithMeta, status) => {
    const file = fileWithMeta.file;

    if (status === "done") {
      try {
        const base64URL = await fileToBase64(file);

        await uploadBanner({
          file: {
            name: file.name,
            base64URL,
          },
        });
      } catch (error) {
        toast.error("Error procesando archivo");
      }
    }

    if (status === "removed") {
      setImageName(null);
    }
  };


  const handleSave = async (e) => {
    e.preventDefault();

    if (!imageName && isEnabled) {
      toast.warning("Debes subir una imagen si el banner está habilitado");
      return;
    }

    await saveBanner({
      image: imageName,
      status: isEnabled,
    });
  };

  const previewUrl = imageName
    ? `${API_BASE_URL}/product/get-file-banner/${imageName}`
    : null;

  if (isLoading) {
    return <div className="text-center mt-5">Cargando configuración...</div>;
  }

  return (
    <Col xxl="12">
      <form onSubmit={handleSave}>
        <Card>
          <CardBody>
            <Row className="mb-4">
              <Col md="6">
                <h5 className="mb-3">Configuración Banner</h5>
              </Col>

              <Col
                md="6"
                className="d-flex align-items-center justify-content-md-end mt-3 mt-md-0"
              >
                <div className="d-flex align-items-center justify-content-end gap-3">
                  <span
                    className={`fw-semibold ${isEnabled ? "text-success" : "text-muted"
                      }`}
                  >
                    {isEnabled ? "Banner Activo" : "Banner Inactivo"}
                  </span>

                  <div
                    onClick={() => toggleBanner({})}
                    style={{
                      width: 55,
                      height: 28,
                      borderRadius: 50,
                      backgroundColor: isEnabled ? "#198754" : "#dee2e6",
                      cursor: "pointer",
                      position: "relative",
                      transition: "all 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        width: 24,
                        height: 24,
                        borderRadius: "50%",
                        backgroundColor: "#fff",
                        position: "absolute",
                        top: 2,
                        left: isEnabled ? 28 : 3,
                        transition: "all 0.3s ease",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                      }}
                    />
                  </div>
                </div>
              </Col>
            </Row>

            <hr />

            {/* Vista previa */}
            <div className="mb-4">
              <h6 className="mb-3">Imagen Actual</h6>

              <div
                style={{
                  width: "100%",
                  minHeight: 300,
                  borderRadius: 12,
                  backgroundColor: "#f8f9fa",
                  border: "2px dashed #dee2e6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                {previewUrl ? (
                  <>
                    <img
                      src={previewUrl}
                      alt="Banner Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                      }}
                    />
                  </>
                ) : (
                  <span className="text-muted">
                    No hay imagen cargada
                  </span>
                )}
              </div>
            </div>

            {/* Dropzone */}
            <div>
              <h6 className="mb-3">Subir / Reemplazar Imagen</h6>

              <Dropzone
                onChangeStatus={handleChangeStatus}
                accept="image/*"
                maxFiles={1}
                multiple={false}
                canCancel={false}
                inputContent="Arrastra o haz clic para subir la imagen"
              />
            </div>
          </CardBody>
        </Card>

        <div className="d-flex justify-content-end gap-2 my-4">
          <Btn
            attrBtn={{
              color: "secondary",
              type: "button",
              onClick: () => navigate(-1),
            }}
          >
            <i className="fa fa-arrow-left me-2"></i> Volver
          </Btn>

          <Btn
            attrBtn={{
              color: "primary",
              type: "submit",
              disabled: saving,
            }}
          >
            <i className="fa fa-save me-2"></i>
            {saving ? "Guardando..." : "Guardar Configuración"}
          </Btn>
        </div>
      </form>
    </Col>
  );
};